<!-- Error -->
<div *ngIf="error" class="state state--error">
    <p-message severity="error" [text]="error"></p-message>
    <button pButton type="button" label="Reintentar" icon="pi pi-refresh"
            class="p-button-sm mt-3" (click)="retry.emit()"></button>
</div>

<!-- Loading -->
<div *ngIf="!error && loading" class="skeleton-grid">
    <p-skeleton *ngFor="let s of skeletons" height="300px" borderRadius="12px"></p-skeleton>
</div>

<!-- Empty -->
<div *ngIf="!error && !loading && results && results.length === 0" class="state state--empty">
    <i class="pi pi-search"></i>
    <p>No encontramos propiedades con esos filtros.</p>
</div>

<!-- Results -->
<app-custom-card *ngIf="!error && !loading && results && results.length"
                 [properties]="results"></app-custom-card>
